// @flow
import styled from 'styled-components';
import { TwoColumnLayoutWithSidebarWidgets } from "../../../components";

export const Layout = styled(TwoColumnLayoutWithSidebarWidgets)`

`;

export default Layout;


// WEBPACK FOOTER //
// ./src/pages/league/team/layout.js